import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Component } from 'react';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UserName from 'automation-ui-references/customer-data/UserName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
class EmailNotificationActionDetail extends Component {
  constructor(...args) {
    super(...args);
    this.renderSubject = () => {
      const {
        actionMetadata: {
          subject
        },
        flowObjectTypeId
      } = this.props;
      return subject && flowObjectTypeId ? /*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(PersonalizedTextView, {
          propertyTypeId: flowObjectTypeId,
          text: `"${subject}"`
        })
      }) : /*#__PURE__*/_jsx(MissingLabel, {
        type: "title"
      });
    };
  }
  renderRecipients(userIds, teamIds, ownerProperties, flowObjectTypeId) {
    if (!(userIds.length + teamIds.length + ownerProperties.length)) {
      return /*#__PURE__*/_jsx(MissingLabel, {
        type: "recipient"
      });
    }
    const recipientList = [].concat(teamIds.map(teamId => /*#__PURE__*/_jsx(TeamName, {
      id: teamId,
      href: null
    }, `team-${teamId}`))).concat(userIds.map(userId => /*#__PURE__*/_jsx(UserName, {
      id: userId,
      href: null
    }, `user-${userId}`))).concat(ownerProperties.map(propertyName => /*#__PURE__*/_jsx(PropertyName, {
      objectTypeId: flowObjectTypeId,
      propertyName: propertyName
    }, `property-${propertyName}`)));
    return /*#__PURE__*/_jsx(FormattedList, {
      children: recipientList
    });
  }
  render() {
    const {
      actionMetadata: {
        teamIds,
        userIds,
        ownerProperties
      },
      messageLangPath,
      flowObjectTypeId
    } = this.props;
    const renderedSubject = this.renderSubject();
    const renderedRecipients = this.renderRecipients(userIds || [], teamIds || [], ownerProperties || [], flowObjectTypeId);
    return /*#__PURE__*/_jsx("div", {
      children: messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.email-notification.action-detail.content",
        options: {
          subject: renderedSubject,
          recipients: renderedRecipients
        }
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.email-notification.action-preview.content",
        options: {
          subject: renderedSubject,
          recipients: renderedRecipients
        }
      })
    });
  }
}
EmailNotificationActionDetail.defaultProps = {
  messageLangPath: 'actionDetail'
};
export default EmailNotificationActionDetail;